import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const referralWithdrawalMenuRegistry = {
    core_referralWithdrawal: {
        label: "Referral Withdrawal",
        link: PAGE_URL.REFERRAL_WITHDRAWAL_PAGE,
        key: PAGE_URL.REFERRAL_WITHDRAWAL_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default referralWithdrawalMenuRegistry;
